/* eslint-disable jsx-a11y/label-has-associated-control , no-prototype-builtins, no-console */ 
import React, { useEffect, useState } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import {Link} from 'react-router-dom'
import styles from './View.Style'
import { Container,Checkbox } from '@material-ui/core'
import * as Yup from 'yup';
import Loading from 'components_newui/Loading';
import Formbuilder from 'components_newui/formBuilder/View'
// import noDraftIdeasImg from 'img/no_draft_idea.png'
// import InvestorsImg from 'img/imgs/investors.svg';
// import NxtCircularLoader from 'components/nxt_circular_loader/View'



const validationSchema = Yup.object().shape({
  templateName: Yup.string()
  .min(3,'Minimum 3 characters')
  .max(100, 'Maximum 100 characters')
  .required('Template Name is required')
  .trim()
  .matches(
    /^[a-zA-Z0-9_ #!?|]*$/,
    'Only letters, numbers, spaces, underscore (_), hash (#), exclamation (!), question mark (?), and pipe (|) are allowed'
  ),
   
});




const UpdateIdeaTemplate = (props) => {
  // console.log("props==",props)
  const  {classes,location, editIdIdeaTemplateData,editIdIdeaTemplateLoading} = props || {}
  // console.log("editIdIdeaTemplateData=>", editIdIdeaTemplateData)
  // const {activeTemplate,createdBy,id,ideaJson,templateName,weightCount} = location && location.state
  const {activeTemplate,createdBy,id,ideaJson,templateName,weightCount} = editIdIdeaTemplateData

  const { match,myEmail,putIdeaTemplateEditFn,updateIdeaTemplateLoading, getIdeaTemplateEditIDFn } = props || {}
  const templateId = match?.params?.id ? Number(match.params.id) : null;
  const [errors, setErrors] = useState({});
  const [isFormValid, setIsFormValid] = useState(false);
    const [scorecardJSONRowFormData, setScorecardJSONRowFormData] = useState([])
  const [ideaTemplatebuilderFormDataChildToParent,setIdeaTemplatebuilderFormDataChildToParent ] = useState([])

  // console.log("scorecardJSONRowFormData 11111=>", scorecardJSONRowFormData )

  let ideaJsonConvertIntoArrOfObj = [];
  try {
    if (ideaJson?.value) {
      ideaJsonConvertIntoArrOfObj = JSON.parse(ideaJson.value);
    }
  } catch (error) {
    console.error("Invalid JSON:", error);
  }
  

  const [ideaTemplateValue,setIdeaTemplateValue ] = useState({
    templateName,
    templateActive:activeTemplate,
    totalWeight:weightCount,
    templateJson:ideaJsonConvertIntoArrOfObj
  })

  useEffect(() => {
    if (templateId !== null) {
      getIdeaTemplateEditIDFn(templateId);
    }
  }, [templateId]);
  

  useEffect(() => {
    if (editIdIdeaTemplateData && Object.keys(editIdIdeaTemplateData).length > 0) {
  
      let parsedJson = [];
      try {
        if (ideaJson?.value) {
          parsedJson = JSON.parse(ideaJson.value);
        }
      } catch (error) {
        console.error("Invalid JSON:", error);
      }
  
      setIdeaTemplateValue({
        templateName: templateName || '',
        templateActive: activeTemplate || false,
        totalWeight: weightCount || 0,
        templateJson: parsedJson
      });
    }
  }, [editIdIdeaTemplateData]);
  


  // const ideaJsonConvertIntoArrOfObj= JSON.parse(ideaJson?.value)
  // console.log("🚀 ~ UpdateScorecardTemplate ~ weightCount:", weightCount)


  const key = 'weight';
  const filteredArrayWeight = ideaTemplatebuilderFormDataChildToParent.filter(obj => obj.hasOwnProperty(key));
  // console.log('filter==>',filteredArrayWeight , ideaTemplateValue);


const overAllWeight = filteredArrayWeight.reduce((accumulator, currentObject) => {
    return accumulator + Number(currentObject.weight);
  }, 0);



useEffect(()=>{
  setIdeaTemplateValue((prev)=>({
    ...prev,
    templateJson:scorecardJSONRowFormData,
    totalWeight:overAllWeight
  }))
},[overAllWeight,scorecardJSONRowFormData])



  // Validate form on every change
  useEffect(() => {
    const validateForm = async () => {
      try {
        await validationSchema.validate(ideaTemplateValue, { abortEarly: false });
        setErrors({});
        setIsFormValid(true);
      } catch (err) {
        const formattedErrors = {};
        err.inner.forEach((error) => {
          formattedErrors[error.path] = error.message;
        });
        setErrors(formattedErrors);
        setIsFormValid(false);
      }
    };

    validateForm();
  }, [ideaTemplateValue]);



  const handleSave = async () => {
    try {
      await validationSchema.validate(ideaTemplateValue, { abortEarly: false });

const jsonDataEditUpdate =
Array.isArray(scorecardJSONRowFormData) && scorecardJSONRowFormData.length > 0
  ? scorecardJSONRowFormData
  : ideaJsonConvertIntoArrOfObj;

      const payload = {
        ...ideaTemplateValue,
        // templateJson: JSON.stringify(scorecardJSONRowFormData) || ideaJsonConvertIntoArrOfObj,

        templateJson: JSON.stringify(jsonDataEditUpdate),
        totalWeight: overAllWeight
      };
  
      await putIdeaTemplateEditFn(myEmail, payload, templateId);
    } catch (error) {
      console.error("Error during save:", error);
    }
  };
  

  // const handleSave = async (jsonData) => {
  //   // Perform save action here, e.g., send data to an API
  //   // const letusData = [...jsonData]
  //   // setScorecardTemplateValue((prev)=>({
  //   //   ...prev,
  //   //   templateJson:JSON.stringify(scoreCardTemplatebuilderFormDataChildToParent),
  //   //   totalWeight:overAllWeight
  //   // }))
  //   // console.log('Data saved:', scorecardTemplateValue, jsonData);
  //   try {
  //     // await validationSchema.validate(scorecardTemplateValue, { abortEarly: false });
  //     // setErrors({});
  //     // setIsFormValid(true);
  //     await putIdeaTemplateEditFn(myEmail,ideaTemplateValue,id)
  //   } catch (error) {
  //     console.log("Error:",error)
  //     // const formattedErrors = {};
  //       // err.inner.forEach((error) => {
  //       //   formattedErrors[error.path] = error.message;
  //       // });
  //       // setErrors(formattedErrors);
  //       // setIsFormValid(false);
  //   }


  // };


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setIdeaTemplateValue(prevState => ({
      ...prevState,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  if (editIdIdeaTemplateLoading) {
    return <Loading />;
  }
  

  // console.log("isFormValid=====> end ", isFormValid)

  return (
    <Container fullWidth={false}>
        <div className={classes.createscorecardwrap} >
           <div className={classes.headingwrp}>
              <h2 className={classes.title}>Edit Idea Template</h2>
            </div>

            <div className={classes.formbox}>
             <div className='block'>
              <div className={classes.fieldbox}>
                <label htmlFor='templateName'  className={classes.labels}>Template Name</label>
                <input 
                  className={classes.inputs} 
                  value={ideaTemplateValue?.templateName}  
                  type='text' 
                  name='templateName' 
                  id='templateName' 
                  onChange={handleChange}
                  required
                  aria-required
                />
                {errors.templateName && <p className={classes.error}>{errors.templateName}</p>}
              </div>

              {/* <div className={classes.fieldbox}>
                <label htmlFor='templateActive' className={classes.labels}>Make Template Active</label>
                
                  <Checkbox
                    id="templateActive"
                    checked={ideaTemplateValue.templateActive}
                    onChange={handleChange}
                    inputProps={{ 'aria-label': 'templateActive' }}
                    name='templateActive'
                  />
              </div> */}
              </div>
              <div className={classes.overallWeight}>
                <p className={classes.labels}>Overall scoring weights</p>
                  <div className={classes.overallBox}>
                    <div className={classes.overallHeading}>
                      <h4 className={classes.heading}>Question</h4>
                      <h4 className={classes.heading}>Weight</h4>
                    </div>
                    {
                      filteredArrayWeight?.map((weight)=>{
                        return(
                          <div key={weight.weight} className={classes.overallWeightRow}>
                            <h4 className={classes.heading}>{weight.label}</h4>
                            <p className={classes.heading}>{weight.weight}</p>
                          </div> 
                        )
                      })
                    }
                    <div className={classes.overallWeightRow}>
                      <h4 className={classes.heading}>Total Weight</h4>
                      <p className={classes.heading}>{overAllWeight}</p>
                    </div>
                  </div>
              </div>
            </div>
            <h3>Create your template</h3>
            <Formbuilder 
              isLoading={updateIdeaTemplateLoading}
              onSave={handleSave} 
              btnDisable={!isFormValid}
              mode='edit'
              sendJsonArrOfObjDataToChild={ideaJsonConvertIntoArrOfObj} 
              setScoreCardTemplatebuilderFormData={setIdeaTemplatebuilderFormDataChildToParent}
              setScorecardJSONRowFormData={setScorecardJSONRowFormData}
            />

        </div>
    </Container>
  )
}


export default withStyles(styles)(UpdateIdeaTemplate)